import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InputField = ({
    label,
  hideLabel = false,
  placeholder,
  addOn,
  validate,
  id,
  icon,
  className,
  value,
  onChange,
  isNumber = false,
  disabled = false,
  isPassword = false,
  autocomplete = true,
  isInvalid = false,
  required = false,
  maxLength,
}) => {
  const [isValid, setIsValid] = useState(null);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    if (isInvalid) setHasInteracted(false);
  }, [isInvalid]);

  const showInvalid = (isInvalid && !hasInteracted) || isValid === false;

  const handleChange = (e) => {
    if (isNumber) {
      e.target.value = parseNumber(e.target.value);
    }
    const newValue = e.target.value;

    if (!hasInteracted) setHasInteracted(true);

    onChange?.(e);

    if (newValue === "") {
      setIsValid(null);
    } else if (validate) {
      setIsValid(validate(newValue));
    }
  };

  const inputClasses = showInvalid
    ? "input-invalid"
    : isValid === null
    ? "input-default"
    : "input-valid";

  return (
    <div className="w-full">
          {!hideLabel && (
              <label
                  htmlFor={id}
                  className={`block text-sm font-bold mb-2 flex flex-row ${isValid === null
                          ? ""
                          : isValid
                              ? "text-secondary-700"
                              : "text-error-700"
                      }`}
              >
                  {label}
                  {required && <p className="text-error-500 text-xs flex">*</p>}
              </label>
          )}


      {/* Hantera input-fältet med eller utan addOn */}
      {addOn ? (
        <div className="input-add-on-wrapper w-full">
          <input
            id={id}
            type={isPassword ? "password" : "text"}
            disabled={disabled}
            autoComplete={autocomplete ? "on" : "new-password"}
            value={isNumber ? parseNumber(value) : value}
            onChange={handleChange}
            className={`input-add-on-field ${inputClasses} ${className} w-full`}
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            placeholder={placeholder}
            maxLength={maxLength}
          />
          <div className="input-add-on">{addOn}</div>{" "}
          {/* Extra element bredvid fältet */}
        </div>
      ) : (
        <div className="flex w-full">
          <div className="relative w-full">
            {icon && (
              <div>
                <FontAwesomeIcon
                  icon={icon}
                  className="w-4 h-4 text-mute-300 ml-4 mt-3 absolute"
                />
              </div>
            )}
            <input
              id={id}
              autoComplete={autocomplete ? "on" : "new-password"}
              type={isPassword ? "password" : "text"}
              disabled={disabled}
              value={isNumber ? parseNumber(value) : value}
              onChange={handleChange}
              className={`w-full ${
                icon ? "input-with-icon" : ""
              } ${inputClasses} ${className}`}
              placeholder={placeholder}
              maxLength={maxLength}
            />
          </div>
        </div>
      )}

      {showInvalid && (
        <p className="text-xs text-error-400">* {label} is required</p>
      )}
    </div>
  );
};

export default InputField;

const parseNumber = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  let text = String(value).replaceAll(",", ".");
  const negative = text.trimStart().startsWith("-");
  text = text.replace(/[^0-9.]/g, "");
  const dot = text.indexOf(".");
  if (dot !== -1) {
    text = text.slice(0, dot + 1) + text.slice(dot + 1).replaceAll(".", "");
  }
  return negative ? `-${text}` : text;
};
